import * as actions from 'redux/constants';
import {
  sendErrorMessage,
  getDefaultMessages,
  iframeMessages
} from 'services/iframeService';
import { HOSTED_PAGE_TYPES, STATUSES } from 'consts';

const {
  sendGetPageFailMsg: sendGetIdvPageFail,
  sendStartMsg: sendStartMessageIdv,
  sendSuccessMsg: sendSuccessMessageIdv,
  sendFailMsg: sendFailMessageIdv
} = getDefaultMessages(HOSTED_PAGE_TYPES.idv);

const idvMiddleware = store => next => action => {
  const {
    global: { isSdk }
  } = store.getState();
  if (!isSdk) {
    return next(action);
  }

  switch (action.type) {
    case actions.GET_IDV_PAGE_FAIL: {
      sendGetIdvPageFail(action.payload.error);
      break;
    }
    case actions.GET_IDV_PAGE_SUCCESS: {
      const { status } = action.payload.data;
      if (status === STATUSES.done) {
        sendGetIdvPageFail('IDV_PAGE_ALREADY_IN_USE');
      }
      break;
    }
    case actions.GET_IDV_DOCUMENTS_FAIL: {
      sendErrorMessage({
        type: iframeMessages.IDV_ON_FAILURE,
        error: action.payload.error
      });
      break;
    }
    case actions.LIVENESS_CHECK_START: {
      sendStartMessageIdv();
      break;
    }
    case actions.LIVENESS_CHECK_SUCCESS: {
      sendSuccessMessageIdv({
        eventType: iframeMessages.IDV_LIVENESS_CHECK_SUCCESS,
        data: action.payload.data
      });
      break;
    }
    case actions.LIVENESS_CHECK_FAIL: {
      sendFailMessageIdv({
        eventType: iframeMessages.IDV_LIVENESS_CHECK_FAIL,
        error: action.payload.error
      });
      break;
    }
    case actions.VERIFY_DOCUMENTS_START: {
      sendStartMessageIdv();
      break;
    }
    case actions.VERIFY_DOCUMENTS_SUCCESS: {
      sendSuccessMessageIdv({
        eventType: iframeMessages.IDV_SUBMIT_SUCCESS,
        data: action.payload.data,
        meta: { closeIframe: true }
      });
      break;
    }
    case actions.VERIFY_DOCUMENTS_FAIL: {
      sendFailMessageIdv({
        eventType: iframeMessages.IDV_SUBMIT_FAIL,
        error: action.payload.error,
        meta: { closeIframe: true }
      });
      break;
    }
  }

  next(action);
};

export default idvMiddleware;
